package api.dataclasses

data class ApiResult<K>(
    val success: Boolean = false,
    val data: K? = null,
    val errorMsg: String? = null,
    var refreshedSession: Session? = null
)
